import { render } from "./StatsViewer.vue?vue&type=template&id=5feacb52"
import script from "./StatsViewer.vue?vue&type=script&lang=js"
export * from "./StatsViewer.vue?vue&type=script&lang=js"

import "./StatsViewer.vue?vue&type=style&index=0&id=5feacb52&lang=scss"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__